import { configQuery, isCoreXQuery } from '@gig/magic-common';
import { GEO_TOKEN_QUERY, GEO_REGION_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { queryGeolocationPermission } from '@gig/magic-geo-location';

var GeoLocationService = /** @class */ (function () {
    function GeoLocationService(mobileAppService) {
        var _this = this;
        if (mobileAppService === void 0) { mobileAppService = null; }
        this.mobileAppService = mobileAppService;
        this.registerQuerySchema();
        configQuery('geoLocation').then(function (config) { return __awaiter(_this, void 0, void 0, function () {
            var container;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!config || ((_a = this.mobileAppService) === null || _a === void 0 ? void 0 : _a.isMobileApp)) {
                            this.subscribeGeoTokenQueryDisabled();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "geo-location" */ '@gig/magic-geo-location/dist/service')];
                    case 1:
                        container = _b.sent();
                        new container.GeoLocationService();
                        return [2 /*return*/];
                }
            });
        }); });
    }
    GeoLocationService.prototype.waitForPermission = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, config, isCoreX;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            configQuery('geoLocation'),
                            isCoreXQuery(),
                        ])];
                    case 1:
                        _b = _c.sent(), config = _b[0], isCoreX = _b[1];
                        if (!config || !isCoreX || !magic.session.getUser() || ((_a = this.mobileAppService) === null || _a === void 0 ? void 0 : _a.isMobileApp)) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, queryGeolocationPermission()];
                                        case 1:
                                            _a.sent();
                                            resolve();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                }
            });
        });
    };
    GeoLocationService.prototype.subscribeGeoTokenQueryDisabled = function () {
        var _this = this;
        window.queryBus.subscribe(GEO_TOKEN_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, undefined];
            });
        }); });
        window.queryBus.subscribe(GEO_REGION_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, undefined];
            });
        }); });
    };
    GeoLocationService.prototype.registerQuerySchema = function () {
        window.queryBus.register(GEO_TOKEN_QUERY, {
            type: 'object',
            required: ['reason'],
            properties: {
                reason: {
                    type: 'string',
                },
                data: {
                    type: 'any',
                },
            },
        });
    };
    return GeoLocationService;
}());

export { GeoLocationService };
